import { REACT_SELECTO_RECTANGLE_Z_INDEX } from 'consts/zIndex'
import { createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    border: 0;
    outline: none;
  }

  /* Keyboard-only focus ring (mouse focus stays ringless). Text fields keep
     their own primary-border focus treatment instead of the outline. */
  :focus-visible {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  input:focus-visible,
  textarea:focus-visible,
  [contenteditable]:focus-visible {
    outline: none;
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  html, body, #root {
      width: 100%;
      height: 100%;
  }

  .selecto-container {
    z-index: ${REACT_SELECTO_RECTANGLE_Z_INDEX} !important;
  }

  body.is-dnd-dragging *,
  body.is-dnd-dragging *::before,
  body.is-dnd-dragging *::after {
    pointer-events: none !important;
    cursor: grabbing !important;
  }
`

export default GlobalStyles
